import { TextTooltip } from "@/components/ui/text-tooltip"
import React from "react"

interface ITooltip {
  title: string | React.ReactNode
  children: React.ReactNode
  tooltipEnabled?: boolean
  side?: "top" | "right" | "bottom" | "left"
  align?: "start" | "center" | "end"
}

function Tooltip({ title, children, tooltipEnabled = true, side, align }: ITooltip) {
  if (!children) {
    return <></>
  }

  if (tooltipEnabled) {
    return (
      <TextTooltip title={title} side={side} align={align}>
        {children}
      </TextTooltip>
    )
  }

  return <>{children}</>
}

export default Tooltip
